import Vue from 'vue'
import Vuex from 'vuex'

import createPersistedState from "vuex-persistedstate"

import preloader from './preloader'
import toast from './toast'
import modals from './modals'
import langs from './langs'
import countries from './countries'
import organsystems from './organsystems'
import dictionaries from './dictionaries'

import auth from './auth'
import dashboard from './dashboard'
import surveys from './surveys'
import questions from './questions'
import users from './users'
import results from './results'
import tests from './tests'
import test from './test'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    preloader,
    toast,
    modals,
    langs,
    countries,
    organsystems,
    dictionaries,

    auth,
    dashboard,
    surveys,
    questions,
    users,
    results,
    tests,
    test,
  },
  plugins: [
    createPersistedState({
      paths: ['countries']
    })
  ],
})
